module.exports = __webpack_public_path__ + "static/media/project6.9a2f4c1f.png";